import { render, staticRenderFns } from "./LatestAchievements.vue?vue&type=template&id=3e23f3fd&"
import script from "./LatestAchievements.vue?vue&type=script&lang=js&"
export * from "./LatestAchievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports